import React from 'react';
import './ContactInfo.css';

import Heading from '../Heading/Heading';



const ContactInfo = ({ contactContent }) => {

  return (
    <div className='contact-info'>

      {/* Form Heading */}
      <Heading title={"Contact Info"} subTitle={"Get In Touch"} sideHeading />

      {/* Loop through the contact array and display each contact info item */}
      {contactContent.map((contact) => (
        <div className='info-item' key={contact.id}>

          {/* Display the contact intro */}
          <div className='intro'>
            <div className='icon'>{contact.icon}</div>
            <h4>{contact.title}</h4> 
          </div>

          {/* Display the contact title and details */}
          <div className='content'>
            {/* Loop through the content array and display each item as a paragraph */}
            {contact.content.map((value, index) => (
              <p key={index}>{value}</p>
            ))}
          </div>

        </div>
      ))}
    </div>
  );

};

export default ContactInfo;